module finadai.app.forgotPassword {
  export var NAME = 'finadai.app.forgotPassword';
  function ForgotPasswordController($scope, $stateParams, authService: services.AuthService) {
    $scope.formData = { email: $stateParams.email };
    $scope.errorMessages = [];
    $scope.successMessage = '';
    $scope.submit = form => {
      if(form.$valid){
        authService.sendInstructions($scope.formData).then(response => {
          $scope.successMessage = response.data.message;
        }, responseError => {
          if(responseError.status == 404){
            $scope.errorMessages = responseError.data.errors['Not Found'];
          }
        });
      }
    }
  }
  export function run(){
    var forgotPassword = angular.module(NAME, []);
    forgotPassword.controller('ForgotPasswordController', ForgotPasswordController)
  }
} finadai.app.forgotPassword.run();